import * as tslib_1 from "tslib";
import { BaseFrameworkAdaptor } from './BaseFrameworkAdaptor';
/**
 * This class provides the Adaptor implementation for ACJS
 */
var ACJSFrameworkAdaptor = /** @class */ (function (_super) {
    tslib_1.__extends(ACJSFrameworkAdaptor, _super);
    function ACJSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ACJSFrameworkAdaptor.prototype.registerModuleWithHost = function (moduleName, simpleXdmDefinition) {
        // Do nothing - ACJS is already registering all core modules.
    };
    ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function (moduleName) {
        return _super.prototype.getProviderByModuleName.call(this, moduleName);
    };
    return ACJSFrameworkAdaptor;
}(BaseFrameworkAdaptor));
/**
 * Use only this instance of ACJSFrameworkAdaptor.
 */
export var acjsFrameworkAdaptor = new ACJSFrameworkAdaptor();
//# sourceMappingURL=ACJSFrameworkAdaptor.js.map